import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "application" }
const _hoisted_2 = { class: "top-app-bar" }
const _hoisted_3 = { class: "top-app-bar-figure" }
const _hoisted_4 = ["src"]

import { theme } from "@/utils/Colors";
import { useRouter } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

_useCssVars(_ctx => ({
  "52768ef2": (_unref(theme).surfaceContainer)
}))

const router = useRouter();

const onTitleClick = () => {
  router.push({
    name: "home",
  });
};

const onContactClick = () => {
  router.push({
    name: "contact",
  });
};

const onPrivacyPolicyClick = () => {
  router.push({
    name: "privacy_policy",
  });
};

const onTermsOfServicesClick = () => {
  router.push({
    name: "terms_of_services",
  });
};

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("figure", _hoisted_3, [
        _createElementVNode("img", {
          class: "top-app-bar-logo",
          src: require(`@/assets/logo_graphity.png`),
          alt: 'Výukové grafové úlohy',
          onClick: onTitleClick
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("p", {
        class: "top-app-bar-title",
        onClick: onTitleClick
      }, " Výukové grafové úlohy ")
    ]),
    _createVNode(_component_router_view),
    _createElementVNode("div", { class: "bottom-app-bar" }, [
      _createElementVNode("p", {
        class: "bottom-app-bar-link",
        onClick: onContactClick
      }, "Kontakt"),
      _createElementVNode("p", {
        class: "bottom-app-bar-link",
        onClick: onPrivacyPolicyClick
      }, " Ochrana osobních údajů "),
      _createElementVNode("p", {
        class: "bottom-app-bar-link",
        onClick: onTermsOfServicesClick
      }, " Podmínky použití ")
    ])
  ]))
}
}

})